//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @return OK
 */
export function externalAccountsGetProviders(countryCode: string, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfAccountProviderDto> {
    let url_ = getBaseUrl() + "/api/external/providers?";
      if (countryCode === undefined || countryCode === null)
        throw new Error("The parameter 'countryCode' must be defined and cannot be null.");
      else
        url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsGetProviders,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsGetProviders?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsGetProviders(_response);
    });
}

function processExternalAccountsGetProviders(response: AxiosResponse): Promise<Types.ListResultDtoOfAccountProviderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfAccountProviderDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfAccountProviderDto>(null as any);
}

/**
 * @return OK
 */
export function externalAccountsGetAccounts(config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfExternalAccountDto> {
    let url_ = getBaseUrl() + "/api/external/accounts";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsGetAccounts,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsGetAccounts?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsGetAccounts(_response);
    });
}

function processExternalAccountsGetAccounts(response: AxiosResponse): Promise<Types.ListResultDtoOfExternalAccountDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfExternalAccountDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfExternalAccountDto>(null as any);
}

/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function externalAccountsGetAccount(provider: string, accountIdentifier?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ExternalAccountDto> {
    let url_ = getBaseUrl() + "/api/external/accounts/{provider}?";
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
    if (accountIdentifier === null)
        throw new Error("The parameter 'accountIdentifier' cannot be null.");
    else if (accountIdentifier !== undefined)
        url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsGetAccount,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsGetAccount?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsGetAccount(_response);
    });
}

function processExternalAccountsGetAccount(response: AxiosResponse): Promise<Types.ExternalAccountDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ExternalAccountDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ExternalAccountDto>(null as any);
}

/**
 * @param accountIdentifier (optional) 
 * @param body (optional) 
 * @return OK
 */
export function externalAccountsUpdateAccount(provider: string, accountIdentifier?: string | undefined, body?: Types.ExternalAccountUpdateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ExternalAccountDto> {
    let url_ = getBaseUrl() + "/api/external/accounts/{provider}?";
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
    if (accountIdentifier === null)
        throw new Error("The parameter 'accountIdentifier' cannot be null.");
    else if (accountIdentifier !== undefined)
        url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsUpdateAccount,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsUpdateAccount?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsUpdateAccount(_response);
    });
}

function processExternalAccountsUpdateAccount(response: AxiosResponse): Promise<Types.ExternalAccountDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ExternalAccountDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ExternalAccountDto>(null as any);
}

/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function externalAccountsDeleteAccount(provider: string, accountIdentifier?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/external/accounts/{provider}?";
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
    if (accountIdentifier === null)
        throw new Error("The parameter 'accountIdentifier' cannot be null.");
    else if (accountIdentifier !== undefined)
        url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsDeleteAccount,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsDeleteAccount?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsDeleteAccount(_response);
    });
}

function processExternalAccountsDeleteAccount(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function externalAccountsGetPortfolios(provider: string, accountIdentifier?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfExternalPortfolioDto> {
    let url_ = getBaseUrl() + "/api/external/accounts/{provider}/investments?";
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
    if (accountIdentifier === null)
        throw new Error("The parameter 'accountIdentifier' cannot be null.");
    else if (accountIdentifier !== undefined)
        url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsGetPortfolios,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsGetPortfolios?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsGetPortfolios(_response);
    });
}

function processExternalAccountsGetPortfolios(response: AxiosResponse): Promise<Types.ListResultDtoOfExternalPortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfExternalPortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfExternalPortfolioDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function externalAccountsAuthenticateInit(provider: string, body?: Types.ProviderAuthenticateInput | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ProviderAuthenticateDto> {
    let url_ = getBaseUrl() + "/api/external/accounts/{provider}/authenticate-init";
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsAuthenticateInit,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsAuthenticateInit?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsAuthenticateInit(_response);
    });
}

function processExternalAccountsAuthenticateInit(response: AxiosResponse): Promise<Types.ProviderAuthenticateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ProviderAuthenticateDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ProviderAuthenticateDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function externalAccountsAuthenticateCollect(provider: string, body?: Types.ExternalAccountAuthenticateCollectDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ProviderAuthenticateCollectDto> {
    let url_ = getBaseUrl() + "/api/external/accounts/{provider}/authenticate-collect";
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsAuthenticateCollect,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsAuthenticateCollect?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsAuthenticateCollect(_response);
    });
}

function processExternalAccountsAuthenticateCollect(response: AxiosResponse): Promise<Types.ProviderAuthenticateCollectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ProviderAuthenticateCollectDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ProviderAuthenticateCollectDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function externalAccountsImportExternalPortfolios(body?: Types.PortfolioImportInput | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/external/accounts/import";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsImportExternalPortfolios,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsImportExternalPortfolios?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsImportExternalPortfolios(_response);
    });
}

function processExternalAccountsImportExternalPortfolios(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function externalAccountsSyncExternalPortfoliosBankId(provider: string, body?: Types.SyncProviderInput | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/external/accounts/{provider}/sync";
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigExternalAccountsSyncExternalPortfoliosBankId,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigExternalAccountsSyncExternalPortfoliosBankId?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExternalAccountsSyncExternalPortfoliosBankId(_response);
    });
}

function processExternalAccountsSyncExternalPortfoliosBankId(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigExternalAccountsGetProviders: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsGetProvidersRequestConfig() {
  return _requestConfigExternalAccountsGetProviders;
}
export function setExternalAccountsGetProvidersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetProviders = value;
}
export function patchExternalAccountsGetProvidersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetProviders = patch(_requestConfigExternalAccountsGetProviders ?? {});
}

let _requestConfigExternalAccountsGetAccounts: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsGetAccountsRequestConfig() {
  return _requestConfigExternalAccountsGetAccounts;
}
export function setExternalAccountsGetAccountsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetAccounts = value;
}
export function patchExternalAccountsGetAccountsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetAccounts = patch(_requestConfigExternalAccountsGetAccounts ?? {});
}

let _requestConfigExternalAccountsGetAccount: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsGetAccountRequestConfig() {
  return _requestConfigExternalAccountsGetAccount;
}
export function setExternalAccountsGetAccountRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetAccount = value;
}
export function patchExternalAccountsGetAccountRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetAccount = patch(_requestConfigExternalAccountsGetAccount ?? {});
}

let _requestConfigExternalAccountsUpdateAccount: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsUpdateAccountRequestConfig() {
  return _requestConfigExternalAccountsUpdateAccount;
}
export function setExternalAccountsUpdateAccountRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsUpdateAccount = value;
}
export function patchExternalAccountsUpdateAccountRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsUpdateAccount = patch(_requestConfigExternalAccountsUpdateAccount ?? {});
}

let _requestConfigExternalAccountsDeleteAccount: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsDeleteAccountRequestConfig() {
  return _requestConfigExternalAccountsDeleteAccount;
}
export function setExternalAccountsDeleteAccountRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsDeleteAccount = value;
}
export function patchExternalAccountsDeleteAccountRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsDeleteAccount = patch(_requestConfigExternalAccountsDeleteAccount ?? {});
}

let _requestConfigExternalAccountsGetPortfolios: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsGetPortfoliosRequestConfig() {
  return _requestConfigExternalAccountsGetPortfolios;
}
export function setExternalAccountsGetPortfoliosRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetPortfolios = value;
}
export function patchExternalAccountsGetPortfoliosRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsGetPortfolios = patch(_requestConfigExternalAccountsGetPortfolios ?? {});
}

let _requestConfigExternalAccountsAuthenticateInit: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsAuthenticateInitRequestConfig() {
  return _requestConfigExternalAccountsAuthenticateInit;
}
export function setExternalAccountsAuthenticateInitRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsAuthenticateInit = value;
}
export function patchExternalAccountsAuthenticateInitRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsAuthenticateInit = patch(_requestConfigExternalAccountsAuthenticateInit ?? {});
}

let _requestConfigExternalAccountsAuthenticateCollect: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsAuthenticateCollectRequestConfig() {
  return _requestConfigExternalAccountsAuthenticateCollect;
}
export function setExternalAccountsAuthenticateCollectRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsAuthenticateCollect = value;
}
export function patchExternalAccountsAuthenticateCollectRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsAuthenticateCollect = patch(_requestConfigExternalAccountsAuthenticateCollect ?? {});
}

let _requestConfigExternalAccountsImportExternalPortfolios: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsImportExternalPortfoliosRequestConfig() {
  return _requestConfigExternalAccountsImportExternalPortfolios;
}
export function setExternalAccountsImportExternalPortfoliosRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsImportExternalPortfolios = value;
}
export function patchExternalAccountsImportExternalPortfoliosRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsImportExternalPortfolios = patch(_requestConfigExternalAccountsImportExternalPortfolios ?? {});
}

let _requestConfigExternalAccountsSyncExternalPortfoliosBankId: Partial<AxiosRequestConfig> | null;
export function getExternalAccountsSyncExternalPortfoliosBankIdRequestConfig() {
  return _requestConfigExternalAccountsSyncExternalPortfoliosBankId;
}
export function setExternalAccountsSyncExternalPortfoliosBankIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsSyncExternalPortfoliosBankId = value;
}
export function patchExternalAccountsSyncExternalPortfoliosBankIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExternalAccountsSyncExternalPortfoliosBankId = patch(_requestConfigExternalAccountsSyncExternalPortfoliosBankId ?? {});
}